/* eslint-disable react/require-default-props */
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import BpmnAdapter from '~/components/Bpmn/BpmnAdapter';
import Details from '~/components/Details';
import {
  getTaskStatusImageAndLabel,
  TaskStatus,
} from '~/components/Details/getStatus';
import InstanceDetails from '~/components/Details/InstanceDetails';
import MainInstanceDetails from '~/components/Details/MainInstanceDetails';
import TabsContainer, { ITab } from '~/components/TabsContainer';
import listFixedDetails from '~/pages/Requests/RequestDetails/fixedDetails';
import listTaskFixedDetails from '~/pages/Tasks/TaskDetails/fixedDetails';
import { IState } from '~/store';
import { getStartEventRequest } from '~/store/modules/activities/actions';
import { getProcessInstanceRequest } from '~/store/modules/processes/actions';
import {
  getTaskListByProcessInstanceRequest,
  getTaskRequest,
} from '~/store/modules/tasks/actions';

interface ExecutionDetailsProps {
  executionInstanceId?: string;
  open: boolean;
  modalState: (opened: boolean) => void;
}

const ExecutionDetails: React.FC<ExecutionDetailsProps> = ({
  executionInstanceId,
  open,
  modalState,
}) => {
  const [tab, setTab] = useState<number>(0);
  const [taskType, setTaskType] = useState<string>();

  const processInstance = useSelector(
    (state: IState) => state.processes.executionInstance,
  );
  const loading = useSelector(
    (state: IState) => state.processes.loadingExecution,
  );

  const dispatch = useDispatch();

  useEffect(() => {
    if (open && executionInstanceId)
      dispatch(getProcessInstanceRequest(executionInstanceId, 'execution'));

    return () => setTab(0);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open]);

  const requestTabs: ITab[] = [
    {
      label: 'Execução',
      value: 0,
      content: (
        <MainInstanceDetails
          process={processInstance}
          loading={loading}
          fixedDetails={listFixedDetails(processInstance)}
        />
      ),
    },
    {
      label: 'Tarefas',
      value: 1,
      content: (
        <InstanceDetails
          getfixedDetails={listTaskFixedDetails}
          instanceList={{
            find: () => {
              if (executionInstanceId)
                dispatch(
                  getTaskListByProcessInstanceRequest(executionInstanceId),
                );
            },
            pathToEntity: 'tasks',
            pathToInstance: 'processTaskList',
            pathToLoading: 'loadingTasksByProcessInstance',
          }}
          instanceDetails={{
            find: (task) => {
              if (task.type === 'userTask') dispatch(getTaskRequest(task.id));
              else if (task.type === 'startEvent')
                dispatch(getStartEventRequest(task.id));
              setTaskType(task.type);
            },
            pathToEntity: taskType === 'userTask' ? 'tasks' : 'activities',
            pathToInstance: taskType === 'userTask' ? 'task' : 'startEvent',
            pathToLoading:
              taskType === 'userTask' ? 'loadingTask' : 'loadingStartEvent',
          }}
          statusProps={{
            statuses: [
              TaskStatus.AVAILABLE,
              TaskStatus.IN_PROGRESS,
              TaskStatus.LATE,
              TaskStatus.COMPLETED,
              TaskStatus.COMPLETED_LATE,
              TaskStatus.DELETED,
            ],
            getStatus: getTaskStatusImageAndLabel,
          }}
        />
      ),
    },
    {
      label: 'Processo',
      value: 2,
      content: <BpmnAdapter processInstanceId={processInstance?.id} />,
    },
  ];

  return (
    <Details
      loading={loading}
      title={processInstance?.nomeExecucao}
      open={open}
      modalState={modalState}
    >
      <TabsContainer
        ariaLabel="execution_tabs"
        value={tab}
        onChange={setTab}
        options={requestTabs}
      />
    </Details>
  );
};

export default ExecutionDetails;
